<template>
  <b-container fluid>
    <b-row class="mb-4 mt-2">
      <b-col>
        {{deliveryTime.desc}}
      </b-col>
    </b-row>
    <b-row class="mb-2 pt-1 pb-1" style="background-color: rgba(0, 0, 0, 0.03);">
      <b-col>
        <span class="font-weight-bold">Material</span>
      </b-col>
      <b-col>
        <span class="font-weight-bold">Lieferzeit*</span>
      </b-col>
    </b-row>
    <b-row v-for="material in materials" :key="material.id" style="border-bottom: 1px solid rgba(0, 0, 0, 0.03);" class="pb-1">
      <b-col>
        {{material.short}}
      </b-col>
      <b-col>
        {{material.delivery}}
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <small>{{deliveryTime.hint}}</small>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import DataDeliveryTime from './../../data/general/deliveryTime'
import DataMaterial from './../../data/main/config/setup/material/materials'

export default {
  data () {
    return {
      deliveryTime: DataDeliveryTime.deliveryTime,
      materials: DataMaterial.materials
    }
  }
}
</script>

<style>
</style>
